import { PlusIcon } from '@langchain/untitled-ui-icons';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HostNewCrumb(props: Partial<BreadcrumbData>) {
  return (
    <Breadcrumb name="New" icon={<PlusIcon className="size-4" />} {...props} />
  );
}
